import { Box, BoxProps } from '@chakra-ui/react';

export const ThirdPartySvg = ({
  src,
  ...props
}: {
  src: string;
} & BoxProps) => {
  return (
    <Box
      {...props}
      __css={{
        mask: `url(${src}) no-repeat center / contain;`,
        backgroundColor: 'currentColor',
      }}
    />
  );
};
